const accordions = document.querySelectorAll(".wp-block-vch-blocks-accordion");

accordions.forEach((accordion) => {
	let btn = accordion.querySelector(
		".wp-block-vch-blocks-accordion__heading button"
	);
	let content = accordion.querySelector(
		".wp-block-vch-blocks-accordion__content"
	);

	content.style.display = "none";

	btn.onclick = () => {
		let expanded = btn.getAttribute("aria-expanded") === "true" || false;

		if (expanded == true) {
			content.style.display = "none";
		} else {
			content.style.display = "block";
		}
		btn.setAttribute("aria-expanded", !expanded);
	};
});
